import { NavigationEntity } from './header.entity.interfaces';

/** Holds all Secondary Navigation content of header E.g., "Travel Info", "Skymiles", "Need Help?" */
export interface SecondaryNavigationEntity extends NavigationEntity {
  pagePath: string;
  details: Details;
}

/** Holds all the contents that display on click of Secondary Navigation of header */
export interface Details {
  mainNavigation?: MainNavigationEntity[] | null;
  childPages?: ChildPagesEntity[] | null;
}

/** Holds left column content that appears on click of Secondary Navigation */
export interface MainNavigationEntity {
  brandLabel: string;
  targetUrl: string;
  imagePathDesktop: string;
  openinnewTab: string;
  altText: string;
}

/** Holds right column content that appears on click of Secondary Navigation */
export interface ChildPagesEntity {
  pageName: string;
  pageUrl: string;
  openinnewTab: string;
}
